const features = [
  {
    id: 1,
    icon: 'ri-shield-check-line',
    title: '安全稳定访问',
    desc: '持续更新最新官方地址，多重线路保障，随时随地安全访问90影视网站，不受地域限制。',
  },
  {
    id: 2,
    icon: 'ri-speed-up-line',
    title: '高清流畅播放',
    desc: '全网片源高清画质，智能CDN加速，支持4K超清播放，看片不卡顿、全集不缓冲。',
  },
  {
    id: 3,
    icon: 'ri-smartphone-line',
    title: '多端同步观影',
    desc: '支持网页端、手机端、平板和APP多设备访问，播放记录云端同步，随时随地继续追剧。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-8 max-w-[1440px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            平台优势
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-[560px] mx-auto">
            为什么选择90影视？三大核心优势为你的观影体验保驾护航
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-[960px] mx-auto">
          {features.map((feat) => (
            <div
              key={feat.id}
              className="group p-6 md:p-8 bg-background-50 rounded-xl border border-background-200/60 hover:border-primary-200/50 transition-all duration-300 text-center cursor-default"
            >
              <div className="w-14 h-14 rounded-2xl bg-primary-100 flex items-center justify-center mx-auto mb-5 group-hover:bg-primary-500 transition-colors">
                <i className={`${feat.icon} text-xl text-primary-500 group-hover:text-white w-6 h-6 flex items-center justify-center`}></i>
              </div>
              <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 mb-3">
                {feat.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feat.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}